import React, {useEffect, useState} from "react"
import { Field } from "formik"
import { TextField } from "formik-material-ui"
import Autocomplete from '@material-ui/lab/Autocomplete'
import {useDispatch, useSelector} from "react-redux"
import {Dialog, DialogContent, DialogTitle, Grid, IconButton, makeStyles, Tooltip, Typography} from "@material-ui/core";
import {Close, Help, MoreHoriz} from "@material-ui/icons";
import {ValueForm} from "../../../Dictionary/components/Dictionaries/Values/ValueForm";
import {DictionaryActions} from "../../../Dictionary/actions/dictionary";
import {Values as DictionaryValues} from "../../../Dictionary/components/Dictionaries/Values";

const useStyles = makeStyles(theme => ({
    default: {
        'width': '100%',
        'padding': '6px 24px 6px 16px',
    },
    dictionary: {
        'width': 'calc(100% - 46px)'
    },
    option: {
        'padding': '0 !important'
    },
    tooltip: {
        "background-color": "#000",
        "font-size": "15px",
        "color": "#fff",
        "padding": "15px 15px",
    }
}))

export const FieldDictionary = (props) => {
    const dispatch = useDispatch()
    const classes = useStyles()
    const { id, label, values, attribute, attributes, setFieldValue, setFieldTouched, setSearch, isSubmitting } = props
    const [name] = useState(props.hasOwnProperty('name') ? props.name : `attributes.${id}`)

    const { items } = useSelector(state => { return {items: state.dictionary.attribute.items.data} })
    const [value, setValue] = useState({ value: props.value })
    const [listeners] = useState((!!attribute.dictionary && !!attribute.dictionary.listeners.length) ? attribute.dictionary.listeners : [])

    const [disabled, setDisabled] = useState(!!(isSubmitting || props.disabled || !!listeners.find(
        listener => !!attributes.find(attr => (attr.dictionary && ((listener.id === attr.dictionary.id) && ((listener.relation === 'one') || !values[attr.id]))))
    )))
    const [dialog, setDialog] = useState(false)
    const [dictionaries, setDictionaries] = useState(false)

    useEffect(() => {
        setDisabled(!!(isSubmitting || props.disabled || !!listeners.find(
            listener => !!attributes.find(attr => (attr.dictionary && ((listener.id === attr.dictionary.id) && ((listener.relation === 'one') || !values[attr.id]))))
        )))
    }, [values, isSubmitting])

    useEffect(() => {
        setValue({ value: props.value ?? (attribute.multiple ? [] : '') })
    }, [props.value])

    const dictionary = (
        <Grid container justify='space-between' alignItems="center" style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); setDialog(true) }}>
            <Grid item><Typography>Добавить значение</Typography></Grid>
            <Grid item>
                <Tooltip
                    title="Если значение отсутствует в списке, вы можете его добавить"
                    placement="right"
                    classes={{tooltip: classes.tooltip}}
                >
                    <IconButton
                        style={{
                            "width": "24px",
                            "height": "24px",
                            "padding": "0"
                        }}
                    >
                        <Help style={{"color": "#485868"}}/>
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    )

    return (
        <Grid container direction='row' justify='space-between' alignItems='center' spacing={2}>
            <Grid item className={classes.dictionary}>
                <Autocomplete
                    multiple={attribute.multiple}
                    filterOptions={options => options}
                    options={ (!!items.length ? items : (!!listeners.length ? [] : ['dictionary'])) }
                    name={`${name}`}
                    disabled={ disabled }
                    getOptionLabel={option => option ? ((option instanceof Object) ? (option.value ?? '') : option) : ''}
                    defaultValue={attribute.multiple ? value.value : value}
                    value={attribute.multiple ? value.value : value}
                    noOptionsText='Данные не найдены'
                    {...(!listeners.length ? {
                        groupBy: () => {
                            return dictionary
                        },
                        classes: {
                            option: classes.option
                        }
                    } : {})}
                    onChange={async (e, value) => {
                        if (attribute.dictionary && !!attribute.dictionary.attributes.length) {
                            const attr = attributes.find(attr => attr.dictionary && !!attribute.dictionary.attributes.find(item => item.listener && (item.type === 'one') && item.dictionary && (item.dictionary.id === attr.dictionary.id)))

                            if (attr) {
                                const item = value?.items.find(item => item.attribute.dictionary?.id === attr.dictionary.id)
                                setFieldValue(`attributes.${attr.id}`, (item ? item.value : null), true)
                            }
                        }

                        setFieldValue(`${name}`, attribute.multiple ? [...new Map(value.map(el => el.hasOwnProperty('value') ? [[el.value, ...(el.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' '), el] : [el, el])).values()].map(el => el.hasOwnProperty('value') ? [el.value, ...(el.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ') : el) : ((value && value.hasOwnProperty('value')) ? [value.value, ...(value.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ') : value))
                    }}
                    onBlur={() => {
                        setValue({ value: props.value })
                        setFieldTouched(`${name}`, true)
                        setSearch({search: null, type: attribute.dictionary.id, attribute: null, listeners: {}})
                    }}
                    renderOption={option => {
                        if (option instanceof Object) {
                            return <Typography className={classes.default}>{[option.value, ...(option.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')}</Typography>
                        }
                        return null
                    }}
                    renderInput={params => (
                        <Field
                            component={ TextField }
                            {...params}
                            InputProps={{
                                ...params.InputProps,
                                onChange: (e) => {
                                    if (!attribute.multiple) {
                                        setValue(e.target.value)
                                    }
                                    setSearch({search: e.target.value, attribute: attribute.id, type: attribute.dictionary.id, listeners: listeners.reduce((obj, listener) => {
                                        obj[listener.id] = values[attributes.find(attr => (attr.dictionary && (listener.id === attr.dictionary.id)))?.id]
                                        return obj
                                    }, {})})
                                }
                            }}
                            name={`${name}`}
                            label={label}
                            fullWidth
                        />
                    )}
                />
            </Grid>
            <Grid item>
                <Tooltip title="Справочник" placement="bottom-end">
                    <div>
                        <IconButton
                            type="button"
                            size="small"
                            disabled={isSubmitting || disabled}
                            onClick={() => {
                                setDictionaries(true)
                            }}
                        >
                            <MoreHoriz/>
                        </IconButton>
                    </div>
                </Tooltip>
            </Grid>
            {dictionaries &&
                <Dialog
                    fullScreen
                    fullWidth={true}
                    open={dictionaries}
                    onClose={() => setDictionaries(false)}
                >
                    <DialogTitle>
                        <Grid container direction='row' justify='flex-end' alignItems='center' spacing={2}>
                            <Grid item>
                                <IconButton
                                    aria-label="Закрыть"
                                    onClick={() => setDictionaries(false)}
                                >
                                    <Close/>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>
                        <DictionaryValues
                            type='dialog'
                            id={attribute.dictionary.id}
                            callback={obj => {
                                if (attribute.dictionary && !!attribute.dictionary.attributes.length) {
                                    const attr = attributes.find(attr => attr.dictionary && !!attribute.dictionary.attributes.find(item => item.listener && (item.type === 'one') && item.dictionary && (item.dictionary.id === attr.dictionary.id)))

                                    if (attr) {
                                        const item = obj?.items.find(item => item.attribute.dictionary.id === attr.dictionary.id)
                                        setFieldValue(`attributes.${attr.id}`, (item ? item.value : null), true)
                                    }
                                }

                                setFieldValue(`${name}`, attribute.multiple ? [...value.value.filter(el => el !== [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')).map(el => el), [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')] : ((obj && obj.hasOwnProperty('value')) ? [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ') : obj), true)
                                setValue({value: attribute.multiple ? [...value.value.filter(el => el !== [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')).map(el => el), [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')] : obj.value})
                                setSearch({search: null, attribute: attribute.id, type: (attribute.dictionary ? attribute.dictionary.id : null), listeners: {}})
                                setDictionaries(false)
                            }}
                        />
                    </DialogContent>
                </Dialog>
            }
            {dialog &&
                <ValueForm
                    open={dialog}
                    handleClose={() => {
                        setDialog(false)
                    }}
                    handleSave={values => {
                        return new Promise((resolve, reject) => {
                            dispatch(DictionaryActions.addItem(attribute.dictionary.id, values)).then(
                                (item) => {
                                    resolve(item)
                                },
                                errors => {
                                    reject(errors)
                                }
                            )
                        })
                    }}
                    dictionary={attribute.dictionary}
                    callback={obj => {
                        if (attribute.dictionary && !!attribute.dictionary.attributes.length) {
                            const attr = attributes.find(attr => attr.dictionary && !!attribute.dictionary.attributes.find(item => item.listener && (item.type === 'one') && item.dictionary && (item.dictionary.id === attr.dictionary.id)))

                            if (attr) {
                                const item = obj?.items.find(item => item.attribute.dictionary.id === attr.dictionary.id)
                                setFieldValue(`attributes.${attr.id}`, (item ? item.value : null), true)
                            }
                        }

                        setFieldValue(`${name}`, attribute.multiple ? [...value.value.filter(el => el !== [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')).map(el => el), [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')] : ((obj && value.hasOwnProperty('value')) ? [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ') : obj), true)
                        setValue({value: attribute.multiple ? [...value.value.filter(el => el !== [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')).map(el => el), [obj.value, ...(obj.items ?? []).filter(item => item.attribute.primary).map(item => item.value)].join(' ')] : obj.value})
                        setSearch({search: null, attribute: attribute.id, type: (attribute.dictionary ? attribute.dictionary.id : null), listeners: {}})
                    }}
                />
            }
        </Grid>
    )
}
